import { Radio } from "lucide-react";
import { useStore } from "zustand";
import { Button } from "@/components/ui/button";
import { authStore } from "@/lib/stores/auth-store";
import { coreStore } from "@/lib/stores/core-store";
import { uiStore } from "@/lib/stores/ui-store";

export function BroadcastBanner() {
	const user = useStore(authStore, (state) => state.user);
	const broadcast = useStore(coreStore, (state) => state.broadcast);
	const activeBroadcastViewer = useStore(
		uiStore,
		(state) => state.activeBroadcastViewer
	);
	const navigate = useStore(uiStore, (state) => state.navigate);
	const handleJoinBroadcast = useStore(
		uiStore,
		(state) => state.handleJoinBroadcast
	);
	const setCombinedActiveTab = useStore(
		uiStore,
		(state) => state.setCombinedActiveTab
	);
	const isBroadcastAudioActive = useStore(
		uiStore,
		(state) => state.isBroadcastAudioActive
	);
	const combinedActiveTab = useStore(
		uiStore,
		(state) => state.combinedActiveTab
	);

	const showAudioIndicator =
		isBroadcastAudioActive && combinedActiveTab !== "broadcast";

	if (!broadcast || user?.uid === broadcast.startedBy) {
		return null;
	}

	const handleOpenBroadcast = async () => {
		if (!activeBroadcastViewer) {
			await handleJoinBroadcast();
		}
		setCombinedActiveTab("broadcast");
		navigate({ type: "voiceChannel" }, { newTab: true });
	};

	const handleFocusBroadcast = () => {
		setCombinedActiveTab("broadcast");
		navigate({ type: "voiceChannel" }, { newTab: true });
	};

	if (activeBroadcastViewer) {
		return (
			<button
				className={`flex w-[calc(100%-1rem)] cursor-pointer items-center gap-2 rounded-lg border p-2 transition-all hover:bg-accent ${
					showAudioIndicator
						? "border-green-500/50 bg-green-500/10 shadow-[0_0_8px_rgba(34,197,94,0.3)]"
						: "bg-card"
				}`}
				onClick={handleFocusBroadcast}
				type="button"
			>
				<Radio
					className={`size-3.5 shrink-0 ${broadcast.status === "live" ? "text-green-500" : "text-yellow-500"} ${showAudioIndicator ? "animate-pulse" : ""}`}
				/>
				<p className="flex-1 truncate text-left font-medium text-sm">
					{broadcast.title}
				</p>
				<span
					className={`shrink-0 rounded px-1.5 py-0.5 font-medium text-xs ${
						broadcast.status === "live"
							? "bg-green-500/20 text-green-500"
							: "bg-yellow-500/20 text-yellow-500"
					}`}
				>
					{broadcast.status === "live" ? "LIVE" : "PAUSED"}
				</span>
			</button>
		);
	}

	return (
		<div
			className={`rounded-lg border p-3 transition-all ${
				showAudioIndicator
					? "border-green-500/50 bg-green-500/10 shadow-[0_0_8px_rgba(34,197,94,0.3)]"
					: "bg-card"
			}`}
		>
			<div className="flex items-center gap-2">
				<Radio
					className={`size-3.5 ${broadcast.status === "live" ? "text-green-500" : "text-yellow-500"} ${showAudioIndicator ? "animate-pulse" : ""}`}
				/>
				<div className="flex-1 overflow-hidden">
					<p className="truncate font-medium text-sm">{broadcast.title}</p>
				</div>
				<span
					className={`rounded px-1.5 py-0.5 font-medium text-xs ${
						broadcast.status === "live"
							? "bg-green-500/20 text-green-500"
							: "bg-yellow-500/20 text-yellow-500"
					}`}
				>
					{broadcast.status === "live" ? "LIVE" : "PAUSED"}
				</span>
			</div>
			<Button
				className={`mt-2 w-full ${showAudioIndicator ? "border-green-500 bg-green-500/20 text-green-600 hover:bg-green-500/30" : ""}`}
				onClick={handleOpenBroadcast}
				size="sm"
				variant="outline"
			>
				Open Broadcast
			</Button>
		</div>
	);
}
